import { render, staticRenderFns } from "./SixCard.vue?vue&type=template&id=5126a782"
import script from "./SixCard.vue?vue&type=script&lang=js"
export * from "./SixCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports